'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _jsBase = require('js-base64');

var _ProjectRenderer = require('components/Projects/ProjectRenderer');

var _ProjectRenderer2 = _interopRequireDefault(_ProjectRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* injects from baggage-loader */

var getProjectBase64SrcImage = function getProjectBase64SrcImage(project) {
  var svgString = _server2.default.renderToStaticMarkup(_react2.default.createElement(_ProjectRenderer2.default, { project: project }));

  var addedXMLNamespace = svgString.replace(/<svg /, '<svg xmlns="http://www.w3.org/2000/svg" ');
  var base64Encoded = _jsBase.Base64.encode(addedXMLNamespace);
  var src = 'data:image/svg+xml;base64,' + base64Encoded;

  return src;
};

exports.default = getProjectBase64SrcImage;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectShareRenderer/getProjectBase64SrcImage.js
// module id = 590
// module chunks = 1